







































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IRole, IUser, IModule } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';
import { client } from '@/store';
const namespace = 'role';
const ns = { namespace };
const accessTypes = [
  {
    name: 'Создание',
    icon: 'mdi-eye',
    value: 'c',
  },
  {
    name: 'Чтение',
    icon: 'mdi-plus',
    value: 'r',
  },
  {
    name: 'Обновление',
    icon: 'mdi-wrench',
    value: 'u',
  },
  {
    name: 'Удаление',
    icon: 'mdi-delete',
    value: 'd',
  },
] as const;

@Component
export default class RoleDetail extends BaseDetail<IRole> {
  @Prop({ default: () => ({}) }) readonly preDefinedValues: any;
  namespace = namespace;
  modules: IModule[] = [];
  accessTypes = accessTypes;
  headers = [
    {
      text: 'Модуль',
      align: 'start',
      sortable: false,
      value: 'title',
    },
    {
      align: 'end',
      sortable: false,
      value: 'access',
    },
  ];
  addModule(module: IRole['modules'][0]) {
    this.entityPatch.modules?.push({ ...module, access: 'crud' });
  }
  get addableModules() {
    const moduleIds = this.entityPatch?.modules?.map(({ id }) => id) || [];
    return this.modules.filter(({ id }) => !moduleIds.includes(id));
  }
  modifyAccess(currentAccess: string, accessType: string) {
    const currentState = currentAccess.includes(accessType);
    if (currentAccess.includes(accessType)) {
      return currentAccess
        .split('')
        .filter((char) => char !== accessType)
        .join('');
    }
    return `${currentAccess}${accessType}`;
  }
  async mounted() {
    await this.loadEntity().then((entity) => {
      const value = entity ? JSON.parse(JSON.stringify(entity.modules)) : [];
      this.setValue(this.entityPatch, 'modules', value);
    });
    if (this.preDefinedValues) {
      for (const [key, value] of Object.entries(this.preDefinedValues)) {
        this.setValue(this.entityPatch, key, value);
      }
    }
  }
  created() {
    client.get('/module/all').then(({ data }) => {
      this.modules = data;
    });
  }
}
